import React from 'react'
import classes from './Loader.module.css'

const Loader = () => (
    <div className={classes.Background}>
        <div className={classes.Loader}>
            <div></div>
            <div></div>
            <div></div>
        </div>
    </div>

)
export default Loader